import { COURSES, EVENTS, USERS } from '../data';
import styles from './DashboardTab.module.css';

export default function DashboardTab() {
  const me = USERS[0];
  const inProgress = COURSES.filter(c => c.done > 0 && c.done < c.lessons).slice(0, 3);

  return (
    <div className="flex-col">
      {/* Hero banner */}
      <div className={styles.heroBanner}>
        <div className={styles.heroEmoji}>🚀</div>
        <div className={styles.heroTitle}>Welcome back, {me.name.split(' ')[0]}! 👋</div>
        <div className={styles.heroSub}>
          You have 3 lessons due this week and a live session today at 3:00 PM.
        </div>
        <div className={styles.heroActions}>
          <button className={styles.heroBtnPrimary}>Continue Learning</button>
          <button className={styles.heroBtnGhost}>View Schedule</button>
        </div>
      </div>

      {/* Stat cards */}
      <div className={styles.statGrid}>
        <div className="stat-card">
          <div className="stat-icon">⚡</div>
          <div className="stat-value">8,450</div>
          <div className="stat-label">Total XP</div>
          <div className="stat-change">Lv.12 Master</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📚</div>
          <div className="stat-value">48</div>
          <div className="stat-label">Lessons Done</div>
          <div className="stat-change">↑ +6 this week</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🔥</div>
          <div className="stat-value">14</div>
          <div className="stat-label">Day Streak</div>
          <div className="stat-change">Keep it up!</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🏆</div>
          <div className="stat-value">#1</div>
          <div className="stat-label">Leaderboard Rank</div>
          <div className="stat-change">↑ +2 positions</div>
        </div>
      </div>

      {/* Bottom cards */}
      <div className="grid-2">
        <div className="card">
          <div className="card-header">
            <div className="card-title">Continue Where You Left Off</div>
            <button className="btn btn-ghost btn-sm ml-auto">View all</button>
          </div>
          <div className="card-body">
            {inProgress.map(c => (
              <div key={c.id} className={styles.resumeRow}>
                <div className={styles.resumeThumb} style={{ background: c.bg }}>{c.emoji}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6, color: 'var(--text)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.title}</div>
                  <div className={styles.progressBar}>
                    <div className={styles.progressFill} style={{ width: `${c.done / c.lessons * 100}%` }} />
                  </div>
                </div>
                <div style={{ fontSize: 12, color: 'var(--accent)', fontWeight: 700, flexShrink: 0 }}>
                  {Math.round(c.done / c.lessons * 100)}%
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <div className="card-title">Today&apos;s Events</div>
            <button className="btn btn-ghost btn-sm ml-auto">Calendar</button>
          </div>
          <div className="card-body">
            {EVENTS.slice(0, 3).map(ev => (
              <div key={ev.id} className={styles.eventItem} style={{ borderLeftColor: ev.color }}>
                <div className={styles.eventTitle}>{ev.title}</div>
                <div className={styles.eventTime}>🕐 {ev.time}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
